class MetaNavigation {
    constructor($container) {
        this.setElements($container)
            .wrapLastWord()
            .registerEvents();
    }

    setElements($container) {
        this.elements = {
            $container,
            $lists: $container.find('.multi-lvl-content-nav__lvl1-item'),
            $links: $container.find('.multi-lvl-content-nav__lvl2-link')
        };

        return this;
    }

    wrapLastWord() {
        this.elements.$links.each((nodeIndex, elem) => {
            var $elem = $(elem);
            var elemText = $elem.text();

            if (!elemText.match(/\s/)) {
                $elem.addClass('last-word-in-link');
            } else {
                let textSplit = elemText.split(" ");
                let lastWord = '<span class="last-word-in-link">' + textSplit.pop() + "</span>";
                textSplit.push(lastWord);
                $elem.html(textSplit.join(" "));
            }
        });

        return this;
    }

    registerEvents() {
        $(window).on('resize', this._onWindowResize.bind(this));
        this._onWindowResize();

        return this;
    }

    _onWindowResize() {
        this.elements.$lists.eqHeight();
    }
}

export default MetaNavigation;